import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Box, Button } from '@material-ui/core';
import info from '../../images/icon-persona-juridica.png';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ValidationComponentProps from '../Models/ValidationComponentProps';

const ValidationMessages: React.FC<ValidationComponentProps>  = (
    {image, subtitle, text, buttonStyle, resetForm}: ValidationComponentProps
) => {
 
    return (
            <Grid container>
                <Grid item sm={7}>
                    <Box pl={5}>
                        <tr id={'validationMessage'}>
                            <td className={image}><img src={info} alt="info"/></td>
                            <td className={subtitle}> {text} </td>
                        </tr>
                    </Box>
                </Grid>
                <Grid item sm={5}>
                    <Box m={1} display="flex" flexDirection="column" alignItems="flex-end">
                        <Button className={buttonStyle} variant="contained"
                                id={'resetForm-button'} onClick={resetForm}>
                            <ArrowBackIosIcon/> Verificar otro CUIT
                        </Button>
                    </Box>
                </Grid>
            </Grid>
    )
}

export default ValidationMessages;